import * as React from "react";
import { IconProps } from "./CalendarIcon";

export const MenuOpenedIcon = React.forwardRef<SVGSVGElement, IconProps>(
    ({ size = 18, title, ...props }, ref) => {
        return (
            <svg
                ref={ref}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 18"
                width={size}
                height={size}
                fill="none"
                role="img"
                aria-hidden={title ? undefined : true}
                {...props}
            >
                {title && <title>{title}</title>}
                <path
                    fill="currentColor"
                    d="M16.2929.2929c.3905-.3905 1.0235-.3905 1.4141 0 .3905.3905.3905 1.0235 0 1.414L10.414 9l7.293 7.293.069.0755a1.0006 1.0006 0 0 1-.069 1.3386 1.0006 1.0006 0 0 1-1.3386.069l-.0755-.069-7.293-7.293-7.293 7.293c-.3905.3905-1.0235.3905-1.414 0-.3905-.3906-.3905-1.0236 0-1.4141L7.5859 9 .2929 1.707c-.3905-.3905-.3905-1.0235 0-1.414.3905-.3905 1.0235-.3905 1.414 0L9 7.5859l7.293-7.293Z"
                />
            </svg>
        );
    }
);

MenuOpenedIcon.displayName = "MenuOpenedIcon";
